export default __webpack_public_path__ + "static/tabs-grouping-do-1f35d7b75ada77515fdd9d9dacc4ae8f639f10b61ecde011c10f93d19717378a.png";